import React from "react";
import MainsTest from "../../data/mains-test.json";

const MainsTestSeriesMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "80px" }}>
      <div className="accordion" id="questionPapersAccordion">
        {MainsTest.map((testseries, index) => (
          <div className="accordion-item" key={testseries.id}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded={testseries.id === 1 ? "true" : false}
                aria-controls={`collapse${index}`}
              >
                {testseries.title}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className={
                testseries.id === 1
                  ? "accordion-collapse collapse show"
                  : "accordion-collapse collapse"
              }
              aria-labelledby={`heading${index}`}
              data-bs-parent="#questionPapersAccordion"
            >
              <div className="accordion-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Topic</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(testseries.series)
                      .filter(([paper, link]) => link?.trim() !== "") // Filter out rows with empty links
                      .map(([paper, link]) => (
                        <tr key={paper}>
                          <td>{paper}</td>
                          <td>
                            <a
                              href={link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-primary"
                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>

      <p
        style={{
          textAlign: "center",
          color: "#d2093c",
          fontWeight: "bold",
          fontSize: "18px",
        }}
      >
        Stay Tuned! More{" "}
        <span style={{ color: "#00306e" }}>Mental Answer Writing (MAW)</span>{" "}
        Tests Coming Soon! ✍️
      </p>
    </div>
  );
};

export default MainsTestSeriesMain;
